import {ModbusSerialPort} from '@models/adminstration/gateway/gateway-configuration/modbus-serial-port';
import {ModbusSlave} from '@models/adminstration/gateway/gateway-configuration/modbus-slave';

export class ModbusSetting {
  polltimeMs: number = 100;
  serialPort: ModbusSerialPort = new ModbusSerialPort();
  slaves: ModbusSlave[] = [];
}